import axios from './axios';
import api from './api.mappings';
export class CommonApi {
    systemConfig() {
        return axios.get(api.common.systemConfig);
    }
    /**
     * 退出登录
     */
    logout(params) {
        return axios.post('/logout', params, {
            headers: {
                Authentication: `Bearer ${params.T}`
            }
        });
    }
    systemErrorCode() {
        return axios.get(api.common.systemErrorCode);
    }
}
